export default "__VITE_ASSET__COT4mxde__"